import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navigation: [],
    loggedIn: false,
    user: null
  },
  mutations: {
    getNavigation(state) {
      axios.get(process.env.VUE_APP_SERVER + "navigation").then(res => {
        state.navigation = res.data.result.filter(l => l.name !== 'photos' && l.name !== 'pages');
      });
    },
    userState(state, user) {
      state.loggedIn = user ? true : false;
      state.user = user ? user : null;
    }
  },
  actions: {
    getNavigationLinks(context) {
      context.commit("getNavigation");
    },
    updateUserState(context, user) {
      context.commit("userState", user);
    }
  },
  getters: {
    navigation: state => state.navigation,
    user: state => state.user
  }
});
